"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.join");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _typeValidation = _interopRequireDefault(require("./typeValidation"));

var PctyGridHeaderActionArea = function PctyGridHeaderActionArea(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled;
  var css = ['pcty-grid-action-area', disabled ? 'pcty-disabled' : ''].filter(function (x) {
    return x.length > 0;
  }).join(' ');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: css
  }, children);
};

PctyGridHeaderActionArea.propTypes = {
  /** The action area content of a 'PctyBindableGrid' header. */
  children: _propTypes.default.node,

  /** Whether or not the component is disabled */
  disabled: _propTypes.default.bool,
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation.default)(props, propName, componentName, 'PctyGridHeaderActionArea');
  }
};
PctyGridHeaderActionArea.defaultProps = {
  disabled: false,
  __TYPE: 'PctyGridHeaderActionArea'
};
var _default = PctyGridHeaderActionArea;
exports.default = _default;